const GET_REQUEST_CARD_REQUEST = "GET_REQUEST_CARD_REQUEST";
const GET_REQUEST_CARD_COMPLETED = "GET_REQUEST_CARD_COMPLETED";
const GET_REQUEST_CARD_ERROR = "GET_REQUEST_CARD_ERROR";

const GET_REQUEST_SYSTEM_REQUEST = "GET_REQUEST_SYSTEM_REQUEST";
const GET_REQUEST_SYSTEM_COMPLETED = "GET_REQUEST_SYSTEM_COMPLETED";
const GET_REQUEST_SYSTEM_ERROR = "GET_REQUEST_SYSTEM_ERROR";

const GET_REQUEST_MAIN_REQUEST = "GET_REQUEST_MAIN_REQUEST";
const GET_REQUEST_MAIN_COMPLETED = "GET_REQUEST_MAIN_COMPLETED";
const GET_REQUEST_MAIN_ERROR = "GET_REQUEST_MAIN_ERROR";

const GET_REQUEST_PLAN_CARD_REQUEST = "GET_REQUEST_PLAN_CARD_REQUEST";
const GET_REQUEST_PLAN_CARD_COMPLETED = "GET_REQUEST_PLAN_CARD_COMPLETED";
const GET_REQUEST_PLAN_CARD_ERROR = "GET_REQUEST_PLAN_CARD_ERROR";

const GET_REQUEST_GROUP_CARD_REQUEST = "GET_REQUEST_GROUP_CARD_REQUEST";
const GET_REQUEST_GROUP_CARD_COMPLETED = "GET_REQUEST_GROUP_CARD_COMPLETED";
const GET_REQUEST_GROUP_CARD_ERROR = "GET_REQUEST_GROUP_CARD_ERROR";

const GET_REQUEST_PROGRAM_CARD_REQUEST = "GET_REQUEST_PROGRAM_CARD_REQUEST";
const GET_REQUEST_PROGRAM_CARD_COMPLETED = "GET_REQUEST_PROGRAM_CARD_COMPLETED";
const GET_REQUEST_PROGRAM_CARD_ERROR = "GET_REQUEST_PROGRAM_CARD_ERROR";

const GET_REQUEST_WORK_INFO_REQUEST = "GET_REQUEST_WORK_INFO_REQUEST";
const GET_REQUEST_WORK_INFO_COMPLETED = "GET_REQUEST_WORK_INFO_COMPLETED";
const GET_REQUEST_WORK_INFO_ERROR = "GET_REQUEST_WORK_INFO_ERROR";

const GET_RELATION_REQUESTS_LIST_REQUEST = "GET_RELATION_REQUESTS_LIST_REQUEST";
const GET_RELATION_REQUESTS_LIST_COMPLETED = "GET_RELATION_REQUESTS_LIST_COMPLETED";
const GET_RELATION_REQUESTS_LIST_ERROR = "GET_RELATION_REQUESTS_LIST_ERROR";

const GET_RELATION_STUDENTS_LIST_REQUEST = "GET_RELATION_STUDENTS_LIST_REQUEST";
const GET_RELATION_STUDENTS_LIST_COMPLETED = "GET_RELATION_STUDENTS_LIST_COMPLETED";
const GET_RELATION_STUDENTS_LIST_ERROR = "GET_RELATION_STUDENTS_LIST_ERROR";

const GET_WORK_PROCESS_LIST_REQUEST = "GET_WORK_PROCESS_LIST_REQUEST";
const GET_WORK_PROCESS_LIST_COMPLETED = "GET_WORK_PROCESS_LIST_COMPLETED";
const GET_WORK_PROCESS_LIST_ERROR = "GET_WORK_PROCESS_LIST_ERROR";

const CHANGE_WORK_STATE_REQUEST = "CHANGE_WORK_STATE_REQUEST";
const CHANGE_WORK_STATE_COMPLETED = "CHANGE_WORK_STATE_COMPLETED";
const CHANGE_WORK_STATE_ERROR = "CHANGE_WORK_STATE_ERROR";

const SET_REQUEST_PLAN_REQUEST = "SET_REQUEST_PLAN_REQUEST";
const SET_REQUEST_PLAN_COMPLETED = "SET_REQUEST_PLAN_COMPLETED";
const SET_REQUEST_PLAN_ERROR = "SET_REQUEST_PLAN_ERROR";

const SET_REQUEST_GROUP_REQUEST = "SET_REQUEST_GROUP_REQUEST";
const SET_REQUEST_GROUP_COMPLETED = "SET_REQUEST_GROUP_COMPLETED";
const SET_REQUEST_GROUP_ERROR = "SET_REQUEST_GROUP_ERROR";

const SET_REQUEST_PROGRAM_REQUEST = "SET_REQUEST_PROGRAM_REQUEST";
const SET_REQUEST_PROGRAM_COMPLETED = "SET_REQUEST_PROGRAM_COMPLETED";
const SET_REQUEST_PROGRAM_ERROR = "SET_REQUEST_PROGRAM_ERROR";

const SET_REQUEST_PERSON_REQUEST = "SET_REQUEST_PERSON_REQUEST";
const SET_REQUEST_PERSON_COMPLETED = "SET_REQUEST_PERSON_COMPLETED";
const SET_REQUEST_PERSON_ERROR = "SET_REQUEST_PERSON_ERROR";

const CREATE_REQUEST_STUDENT_REQUEST = "CREATE_REQUEST_STUDENT_REQUEST";
const CREATE_REQUEST_STUDENT_COMPLETED = "CREATE_REQUEST_STUDENT_COMPLETED";
const CREATE_REQUEST_STUDENT_ERROR = "CREATE_REQUEST_STUDENT_ERROR";

const SET_REQUEST_STUDENT_REQUEST = "SET_REQUEST_STUDENT_REQUEST";
const SET_REQUEST_STUDENT_COMPLETED = "SET_REQUEST_STUDENT_COMPLETED";
const SET_REQUEST_STUDENT_ERROR = "SET_REQUEST_STUDENT_ERROR";

const CREATE_REQUEST_PROGRAM_REQUEST = "CREATE_REQUEST_PROGRAM_REQUEST";
const CREATE_REQUEST_PROGRAM_COMPLETED = "CREATE_REQUEST_PROGRAM_COMPLETED";
const CREATE_REQUEST_PROGRAM_ERROR = "CREATE_REQUEST_PROGRAM_ERROR";

const CREATE_REQUEST_PERSON_REQUEST = "CREATE_REQUEST_PERSON_REQUEST";
const CREATE_REQUEST_PERSON_COMPLETED = "CREATE_REQUEST_PERSON_COMPLETED";
const CREATE_REQUEST_PERSON_ERROR = "CREATE_REQUEST_PERSON_ERROR";

const SEARCH_MATCH_PERSON_REQUEST = "SEARCH_MATCH_PERSON_REQUEST";
const SEARCH_MATCH_PERSON_COMPLETE = "SEARCH_MATCH_PERSON_COMPLETE";
const SEARCH_MATCH_PERSON_ERROR = "SEARCH_MATCH_PERSON_ERROR";

const DELETE_REQUEST_PROGRAM_REQUEST = "DELETE_REQUEST_PROGRAM_REQUEST";
const DELETE_REQUEST_PROGRAM_COMPLETED = "DELETE_REQUEST_PROGRAM_COMPLETED";
const DELETE_REQUEST_PROGRAM_ERROR = "DELETE_REQUEST_PROGRAM_ERROR";

const CALCULATE_REQUEST_SIMILAR_REQUEST = "CALCULATE_REQUEST_SIMILAR_REQUEST";
const CALCULATE_REQUEST_SIMILAR_COMPLETED = "CALCULATE_REQUEST_SIMILAR_COMPLETED";
const CALCULATE_REQUEST_SIMILAR_ERROR = "CALCULATE_REQUEST_SIMILAR_ERROR";

const GET_REQUEST_PROGRAM_FILTERS_REQUEST = "GET_REQUEST_PROGRAM_FILTERS_REQUEST";
const GET_REQUEST_PROGRAM_FILTERS_COMPLETED = "GET_REQUEST_PROGRAM_FILTERS_COMPLETED";
const GET_REQUEST_PROGRAM_FILTERS_ERROR = "GET_REQUEST_PROGRAM_FILTERS_ERROR";

export default {
  GET_REQUEST_CARD_REQUEST,
  GET_REQUEST_CARD_COMPLETED,
  GET_REQUEST_CARD_ERROR,

  GET_REQUEST_SYSTEM_REQUEST,
  GET_REQUEST_SYSTEM_COMPLETED,
  GET_REQUEST_SYSTEM_ERROR,

  GET_REQUEST_MAIN_REQUEST,
  GET_REQUEST_MAIN_COMPLETED,
  GET_REQUEST_MAIN_ERROR,

  GET_RELATION_REQUESTS_LIST_REQUEST,
  GET_RELATION_REQUESTS_LIST_COMPLETED,
  GET_RELATION_REQUESTS_LIST_ERROR,

  GET_RELATION_STUDENTS_LIST_REQUEST,
  GET_RELATION_STUDENTS_LIST_COMPLETED,
  GET_RELATION_STUDENTS_LIST_ERROR,

  GET_REQUEST_WORK_INFO_REQUEST,
  GET_REQUEST_WORK_INFO_COMPLETED,
  GET_REQUEST_WORK_INFO_ERROR,

  GET_WORK_PROCESS_LIST_REQUEST,
  GET_WORK_PROCESS_LIST_COMPLETED,
  GET_WORK_PROCESS_LIST_ERROR,

  CHANGE_WORK_STATE_REQUEST,
  CHANGE_WORK_STATE_COMPLETED,
  CHANGE_WORK_STATE_ERROR,

  SET_REQUEST_PLAN_REQUEST,
  SET_REQUEST_PLAN_COMPLETED,
  SET_REQUEST_PLAN_ERROR,

  SET_REQUEST_GROUP_REQUEST,
  SET_REQUEST_GROUP_COMPLETED,
  SET_REQUEST_GROUP_ERROR,

  SET_REQUEST_PERSON_REQUEST,
  SET_REQUEST_PERSON_COMPLETED,
  SET_REQUEST_PERSON_ERROR,

  CREATE_REQUEST_PROGRAM_REQUEST,
  CREATE_REQUEST_PROGRAM_COMPLETED,
  CREATE_REQUEST_PROGRAM_ERROR,

  CREATE_REQUEST_PERSON_REQUEST,
  CREATE_REQUEST_PERSON_COMPLETED,
  CREATE_REQUEST_PERSON_ERROR,

  CREATE_REQUEST_STUDENT_REQUEST,
  CREATE_REQUEST_STUDENT_COMPLETED,
  CREATE_REQUEST_STUDENT_ERROR,

  SET_REQUEST_STUDENT_REQUEST,
  SET_REQUEST_STUDENT_COMPLETED,
  SET_REQUEST_STUDENT_ERROR,

  GET_REQUEST_PLAN_CARD_REQUEST,
  GET_REQUEST_PLAN_CARD_COMPLETED,
  GET_REQUEST_PLAN_CARD_ERROR,

  GET_REQUEST_GROUP_CARD_REQUEST,
  GET_REQUEST_GROUP_CARD_COMPLETED,
  GET_REQUEST_GROUP_CARD_ERROR,

  GET_REQUEST_PROGRAM_CARD_REQUEST,
  GET_REQUEST_PROGRAM_CARD_COMPLETED,
  GET_REQUEST_PROGRAM_CARD_ERROR,

  SET_REQUEST_PROGRAM_REQUEST,
  SET_REQUEST_PROGRAM_COMPLETED,
  SET_REQUEST_PROGRAM_ERROR,

  SEARCH_MATCH_PERSON_REQUEST,
  SEARCH_MATCH_PERSON_COMPLETE,
  SEARCH_MATCH_PERSON_ERROR,

  DELETE_REQUEST_PROGRAM_REQUEST,
  DELETE_REQUEST_PROGRAM_COMPLETED,
  DELETE_REQUEST_PROGRAM_ERROR,

  CALCULATE_REQUEST_SIMILAR_REQUEST,
  CALCULATE_REQUEST_SIMILAR_COMPLETED,
  CALCULATE_REQUEST_SIMILAR_ERROR,

  GET_REQUEST_PROGRAM_FILTERS_REQUEST,
  GET_REQUEST_PROGRAM_FILTERS_COMPLETED,
  GET_REQUEST_PROGRAM_FILTERS_ERROR
}
